var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMutation } from '@tanstack/react-query';
import { useApi } from 'hooks';
var useDeleteAccount = function () {
    var apiFetch = useApi().apiFetch;
    var mutationFn = function () {
        var url = '/me/delete';
        return apiFetch({ method: 'POST', url: url })
            .then(function (res) { return res.data; });
    };
    var _a = useMutation({ mutationFn: mutationFn }), deleteAccount = _a.mutateAsync, rest = __rest(_a, ["mutateAsync"]);
    return __assign({ deleteAccount: deleteAccount }, rest);
};
export default useDeleteAccount;
